module.exports = __webpack_public_path__ + "img/1529982576.248065d4.jpg";